module.exports = __webpack_public_path__ + "static/media/addnewbookActive.b81cb502.svg";